<template>
  <div>
    <Swiper :datas="swiperData" :opts="''" @events="swiperEvents" />
    <div class="kefu_main">
      <div class="kefu_title">
        <img src="@/assets/huodong_dot.png" alt="">
        <span class="ml_05">客服中心</span>
      </div>
      <div class="kefu_item" v-for="(item, index) in kefus" :key="index">
        <img class="kefu_item_img" src="@/assets/go_to.png" alt="">
        <div class="kefu_name">【 {{item.name}} 】</div>
        <div class="kefu_code">
          {{item.type}}：<span >{{item.code}}</span>
          <span class="copy_but" :data-clipboard-text="item.code" @click="onClip()">复制</span>
        </div>
      </div>
    </div>
    <div class="toast_main" v-show="isShowToast">
      <span class="toast_div">已复制</span>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Swiper from '@/components/common/Swiper.vue'
import Clipboard from 'clipboard'

export default {
  name: 'ServiceMobile',
  components: {
    Swiper
  },
  data: () => {
    return {
      isShowToast: false
    }
  },
  methods: {
    // 轮播事件返回
    swiperEvents (vtype, vitem, vid) {
      console.log(vtype, vitem, vid)
    },
    onClip () {
      const self = this
      const tclip = new Clipboard('.copy_but')
      tclip.on('success', function (e) {
        self.isShowToast = true
        setTimeout(() => {
          self.isShowToast = false
        }, 2000)
      })
      tclip.on('error', function (e) {
        console.log(e)
      })
    }
  },
  computed: {
    swiperData () {
      return this.$store.state.configs.swiperData
    },
    kefus () {
      return this.$store.state.configs.kefus
    }
  }
}
</script>
<style scoped>
.kefu_main {
  padding: 2rem;
}
.kefu_title {
  text-align: left;
  margin-bottom: 1rem;
}
.kefu_item {
  color: #fff;
  position: relative;
  background-image: linear-gradient(to right, rgba(191, 224, 255, 1) , rgba(85, 181, 233, 1));
  margin: 0.5rem 0;
  padding: 1rem 1rem;
  text-align: right;
}
.kefu_item_img {
  position: absolute;
  left: 1rem;
  top: 1rem;
  height: 2.6rem;
}
.kefu_name {
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.3rem;
}
.kefu_code {
  font-size: 0.9rem;
}
.copy_but {
  margin-left: 0.8rem;
  border: 1px rgb(38, 118, 160) solid;
  border-radius: 3px;
  color: rgb(246,247,251);
  padding: 1px 6px 3px 6px;
  background: rgb(48, 150, 206);
  font-size: 0.8rem;
}
.toast_main {
  position: fixed;
  top: 50%;
  width: 100%;
  z-index: 99999;
}
.toast_div {
  border: 1px #666 solid;
  padding: 1rem 2rem;
  border-radius: 3px;
  background: #fff;
  color: #666;
}
</style>
